var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.126,
    viewBox: "0 0 16 16.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1466",
    "data-name": "Grupo 1466",
    transform: "translate(-706.5 -493.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit",
    "data-name": "Icon feather-edit",
    transform: "translate(704 491.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7294",
    "data-name": "Trazado 7294",
    d: "M9.709,6H4.491A1.491,1.491,0,0,0,3,7.491V17.928a1.491,1.491,0,0,0,1.491,1.491H14.928a1.491,1.491,0,0,0,1.491-1.491V12.709",
    transform: "translate(0 -1.601)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7295",
    "data-name": "Trazado 7295",
    d: "M19.828,3.281a1.581,1.581,0,0,1,2.236,2.236L14.982,12.6,12,13.345l.745-2.982Z",
    transform: "translate(-4.527)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dc520401ebf7affcd2ad53efd1116ade.svg";
export { ForwardRef as ReactComponent };